var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"value-widget"},[_c('h1',{staticClass:"text-center",style:('color: ' + (_vm.opts.color || 'white') + ';')},[_vm._v(_vm._s(_vm.opts.value)+_vm._s(_vm.options.suffix || ''))])])}
var staticRenderFns = []

export { render, staticRenderFns }